import apiFetch from 'api/base'
import { AxiosPromise } from 'axios'

export interface IRegisterData {
  code: string
}

const googleIdToken = (data: IRegisterData): AxiosPromise =>
  apiFetch(`/socialauth/google/id-token`, { data, method: `POST` })

export default googleIdToken
